import React, { FC } from 'react';

import { SvgIconProps } from './SvgIcon.interface';

export const SvgIcon: FC<SvgIconProps> = props => {
    const { children, className } = props;

    return <span className={className}>{children}</span>;
};
